/** Значки макетов (24 × 24) с цветом, как на макете. Ключ — `icon-<имя>` в `textures.ts`. */

const icon = (body: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">${body}</svg>`;

const INK = '#120B2A';

const vessel = (body: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${body}</svg>`;

export const ICONS: Readonly<Record<string, string>> = {
  play: icon(`<path d="M7 4.5v15l12.5-7.5z" fill="#7FF5E6"/>`),
  'play-ink': icon(`<path d="M7 4.5v15l12.5-7.5z" fill="${INK}"/>`),
  map: icon(
    `<path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z M9 4v14M15 6v14" stroke="${INK}" stroke-width="2" fill="none" stroke-linejoin="round"/>`,
  ),
  duel: icon(
    `<path d="M4 4l9 9M4 4h4M4 4v4M20 4l-9 9M20 4h-4M20 4v4M7 17l-3 3M17 17l3 3M6 14l4 4M18 14l-4 4" stroke="${INK}" stroke-width="2.2" fill="none" stroke-linecap="round"/>`,
  ),
  coop: icon(
    `<circle cx="8" cy="8" r="3.4" fill="${INK}"/><circle cx="16.5" cy="8" r="3.4" fill="${INK}"/><path d="M1.5 20c.8-3.8 3.3-5.6 6.5-5.6s5.7 1.8 6.5 5.6zM13 14.8c1-.3 2.2-.4 3.5-.4 3.2 0 5.7 1.8 6.5 5.6h-7.2" fill="${INK}"/>`,
  ),
  'map-light': icon(
    `<path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z M9 4v14M15 6v14" stroke="#7FF5E6" stroke-width="2" fill="none" stroke-linejoin="round"/>`,
  ),
  // Способности Дуэли и Кооператива (макеты «Дуэль» и «Кооператив»).
  'ability-fever': icon(
    `<path d="M12 3c2 3 5 5 5 9.5a5 5 0 0 1-10 0c0-2 1-3.5 2-4.5.5 2 1.5 3 2.5 3-.5-3 .5-5.5.5-8z" fill="#FF7A3D" stroke="${INK}" stroke-width="1.4" stroke-linejoin="round"/>`,
  ),
  'ability-immunity': icon(
    `<path d="M12 3l7 3v5.5c0 4.4-3 8-7 9.5-4-1.5-7-5.1-7-9.5V6z" fill="none" stroke="#9EF2C9" stroke-width="2.2" stroke-linejoin="round"/><path d="M8.6 12.2l2.4 2.4 4.4-4.6" stroke="#9EF2C9" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'ability-scanner': icon(
    `<circle cx="11" cy="11" r="6" stroke="#FFE08A" stroke-width="2.2" fill="none"/><path d="M15.5 15.5L20 20M8 11h6M11 8v6" stroke="#FFE08A" stroke-width="2.2" stroke-linecap="round"/>`,
  ),
  // Экранные кнопки телефона: сдвиг, поворот, ускорение, сброс.
  'pad-left': icon(
    `<path d="M15 4l-8 8 8 8" stroke="#F2FBFF" stroke-width="3.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'pad-right': icon(
    `<path d="M9 4l8 8-8 8" stroke="#F2FBFF" stroke-width="3.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'pad-down': icon(
    `<path d="M5 9l7 7 7-7" stroke="#F2FBFF" stroke-width="3.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'pad-drop': icon(
    `<path d="M5 5l7 6 7-6M5 12l7 6 7-6" stroke="#7FF5E6" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 21.5h16" stroke="#7FF5E6" stroke-width="2.6" stroke-linecap="round"/>`,
  ),
  'pad-cw': icon(
    `<path d="M19 12a7 7 0 1 1-2.05-4.95M19 4v4.5h-4.5" stroke="#FFD23A" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'pad-ccw': icon(
    `<path d="M5 12a7 7 0 1 0 2.05-4.95M5 4v4.5h4.5" stroke="#FFD23A" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'play-gold': icon(`<path d="M7 4.5v15l12.5-7.5z" fill="#FFD23A"/>`),
  search: icon(
    `<circle cx="10" cy="10" r="6" stroke="#7FF5E6" stroke-width="2.2" fill="none"/><path d="M14.5 14.5L20 20" stroke="#7FF5E6" stroke-width="2.6" stroke-linecap="round"/>`,
  ),
  book: icon(
    `<path d="M4 5.5C4 4.7 4.7 4 5.5 4H11v16H5.5c-.8 0-1.5-.7-1.5-1.5zM20 5.5c0-.8-.7-1.5-1.5-1.5H13v16h5.5c.8 0 1.5-.7 1.5-1.5z" fill="#7FF5E6"/>`,
  ),
  cart: icon(
    `<path d="M3 4h2.5l2.2 11h11l2-8H7" stroke="#FFD23A" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="19.5" r="1.7" fill="#FFD23A"/><circle cx="17" cy="19.5" r="1.7" fill="#FFD23A"/>`,
  ),
  user: icon(
    `<circle cx="12" cy="9" r="4" fill="${INK}"/><path d="M4.5 21c1-4.2 4-6.2 7.5-6.2s6.5 2 7.5 6.2z" fill="${INK}"/>`,
  ),
  gear: icon(
    `<circle cx="12" cy="12" r="3.2" stroke="#F2FBFF" stroke-width="2" fill="none"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1" stroke="#F2FBFF" stroke-width="2" stroke-linecap="round"/>`,
  ),
  lock: icon(
    `<rect x="5" y="10.5" width="14" height="10" rx="2.5" fill="#9FC4D6"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke="#9FC4D6" stroke-width="2.2" fill="none"/>`,
  ),
  back: icon(
    `<path d="M15 5l-7 7 7 7" stroke="#F2FBFF" stroke-width="2.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  check: icon(
    `<path d="M4 12.5l5 5L20 6.5" stroke="${INK}" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  // Сосуды глав (макет «Экспедиция»), рисунок 64 × 64.
  'vessel-jar': vessel(
    `<rect x="19" y="6" width="26" height="8" rx="2" fill="#C27A3E" stroke="${INK}" stroke-width="2"/><rect x="14" y="14" width="36" height="44" rx="9" fill="#0E3446" stroke="#9EDCF0" stroke-width="2.6"/><path d="M17 36h30v12a7 7 0 0 1-7 7H24a7 7 0 0 1-7-7z" fill="#36E2D0" fill-opacity="0.45"/><circle cx="26" cy="44" r="4" fill="#9B6BFF" stroke="${INK}" stroke-width="1.4"/><circle cx="38" cy="47" r="3.4" fill="#FFD23A" stroke="${INK}" stroke-width="1.4"/><path d="M19 20v10" stroke="#FFFFFF" stroke-opacity="0.35" stroke-width="2.4" stroke-linecap="round"/>`,
  ),
  'vessel-tube': vessel(
    `<rect x="22" y="4" width="20" height="5" rx="2" fill="#9EDCF0" stroke="${INK}" stroke-width="1.6"/><path d="M25 9h14v40a7 7 0 0 1-14 0z" fill="#0E3446" stroke="#9EDCF0" stroke-width="2.6"/><path d="M27 34h10v15a5 5 0 0 1-10 0z" fill="#FF4F7B" fill-opacity="0.5"/><path d="M28.5 13v14" stroke="#FFFFFF" stroke-opacity="0.35" stroke-width="2.2" stroke-linecap="round"/>`,
  ),
  'vessel-petri': vessel(
    `<ellipse cx="32" cy="42" rx="27" ry="10" fill="#0E3446" stroke="#9EDCF0" stroke-width="2.6"/><ellipse cx="32" cy="36" rx="27" ry="10" fill="rgba(158, 220, 240, 0.12)" stroke="#9EDCF0" stroke-width="2.2"/><circle cx="22" cy="38" r="3" fill="#FFD23A"/><circle cx="36" cy="40" r="2.4" fill="#9B6BFF"/><circle cx="43" cy="36" r="2" fill="#FF4F7B"/>`,
  ),
  'vessel-flask': vessel(
    `<rect x="24" y="3" width="16" height="5" rx="2" fill="#9EDCF0" stroke="${INK}" stroke-width="1.6"/><path d="M26 8h12v14l14 28a4 4 0 0 1-3.6 6H13.6A4 4 0 0 1 10 50l14-28z" fill="#0E3446" stroke="#9EDCF0" stroke-width="2.6" stroke-linejoin="round"/><path d="M17 40h30l5 10a3 3 0 0 1-2.7 4H14.7a3 3 0 0 1-2.7-4z" fill="#9B6BFF" fill-opacity="0.5"/>`,
  ),
  'vessel-bioreactor': vessel(
    `<path d="M6 24h10M48 30h10M6 44h10" stroke="#C27A3E" stroke-width="4" stroke-linecap="round"/><rect x="16" y="10" width="32" height="48" rx="8" fill="#0E3446" stroke="#9EDCF0" stroke-width="2.6"/><rect x="16" y="8" width="32" height="7" rx="3" fill="#C27A3E" stroke="${INK}" stroke-width="1.6"/><path d="M19 32h26v18a5 5 0 0 1-5 5H24a5 5 0 0 1-5-5z" fill="#36E2D0" fill-opacity="0.5"/><circle cx="32" cy="23" r="5" fill="${INK}" stroke="#FFD23A" stroke-width="1.6"/><path d="M32 23l3-2" stroke="#FFD23A" stroke-width="1.6" stroke-linecap="round"/>`,
  ),
  // Способности соло: «Криотерапия» — снежинка (макет), «Антибиотик» — капсула с крестом.
  'ability-cryo': icon(
    `<path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7" stroke="#BFEAFF" stroke-width="2" stroke-linecap="round"/>`,
  ),
  'ability-antibiotic': icon(
    `<g transform="rotate(-40 12 12)"><path d="M12 8H8a4 4 0 0 0 0 8h4z" fill="#FFFFFF"/><path d="M12 8h4a4 4 0 0 1 0 8h-4z" fill="#36E2D0"/><rect x="4" y="8" width="16" height="8" rx="4" fill="none" stroke="${INK}" stroke-width="1.4"/></g><path d="M18.5 2.5v5M16 5h5" stroke="#FF4F7B" stroke-width="2" stroke-linecap="round"/>`,
  ),
  // Бой соло (макет «Соло · Босс (v2)»): звук, музыка, пауза, действия паузы.
  music: icon(
    `<path d="M9 18V5l11-2v13" stroke="#F2FBFF" stroke-width="2" fill="none" stroke-linejoin="round"/><circle cx="6.5" cy="18" r="2.8" fill="#F2FBFF"/><circle cx="17.5" cy="16" r="2.8" fill="#F2FBFF"/>`,
  ),
  'music-off': icon(
    `<path d="M9 18V5l11-2v13" stroke="#7F9DB0" stroke-width="2" fill="none" stroke-linejoin="round"/><circle cx="6.5" cy="18" r="2.8" fill="#7F9DB0"/><circle cx="17.5" cy="16" r="2.8" fill="#7F9DB0"/><path d="M3 3l18 18" stroke="#FF8FB0" stroke-width="2.4" stroke-linecap="round"/>`,
  ),
  sound: icon(
    `<path d="M4 9h4l5-4v14l-5-4H4z" fill="#F2FBFF"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="#F2FBFF" stroke-width="2" fill="none" stroke-linecap="round"/>`,
  ),
  'sound-off': icon(
    `<path d="M4 9h4l5-4v14l-5-4H4z" fill="#7F9DB0"/><path d="M16 9l5 6M21 9l-5 6" stroke="#FF8FB0" stroke-width="2.2" stroke-linecap="round"/>`,
  ),
  pause: icon(
    `<path d="M8 5v14M16 5v14" stroke="#F2FBFF" stroke-width="3.4" stroke-linecap="round"/>`,
  ),
  restart: icon(
    `<path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v5h5" stroke="#7FF5E6" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  exit: icon(
    `<path d="M14 4h5v16h-5M10 8l-4 4 4 4M6 12h10" stroke="#FF8FB0" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  crown: icon(
    `<path d="M3 18l2-11 5 5 2-8 2 8 5-5 2 11z" fill="#FFD23A" stroke="${INK}" stroke-width="1.5" stroke-linejoin="round"/>`,
  ),
  // Способности боссов: «Репликация» и «Подъём дна» — с макета, остальные — в том же стиле.
  'boss-replicate': icon(
    `<circle cx="8" cy="9" r="4.5" fill="#FFFFFF" stroke="${INK}" stroke-width="1.6"/><circle cx="16.5" cy="15.5" r="3.5" fill="#FFFFFF" stroke="${INK}" stroke-width="1.6"/><path d="M18 3v6M15 6h6" stroke="${INK}" stroke-width="2" stroke-linecap="round"/>`,
  ),
  'boss-raise-floor': icon(
    `<path d="M12 20V6M6 11l6-6 6 6M4 21h16" stroke="#FFFFFF" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'boss-mutate': icon(
    `<path d="M5 8h11l-3-3M19 16H8l3 3" stroke="#FFFFFF" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  'boss-fog': icon(
    `<path d="M6 17h11a4 4 0 0 0 .5-8A6 6 0 0 0 6.3 10 3.5 3.5 0 0 0 6 17z" fill="#FFFFFF" stroke="${INK}" stroke-width="1.4"/><path d="M5 21h14" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>`,
  ),
  'boss-regrow': icon(
    `<path d="M12 21V11M12 11c0-4 3-7 7-7 0 4-3 7-7 7zM12 14c0-3-2.5-5-6-5 0 3 2.5 5 6 5z" fill="#FFFFFF" stroke="${INK}" stroke-width="1.4" stroke-linejoin="round"/>`,
  ),
  'boss-storm': icon(
    `<path d="M13 2L5 13h6l-2 9 9-12h-6z" fill="#FFFFFF" stroke="${INK}" stroke-width="1.4" stroke-linejoin="round"/>`,
  ),
  'boss-latency': icon(
    `<path d="M4 6h6l-6 7h6M13 12h5l-5 6h5" stroke="#FFFFFF" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`,
  ),
  scene: icon(
    `<rect x="3" y="4" width="18" height="14" rx="3" fill="none" stroke="#FFD23A" stroke-width="2"/><path d="M8 18l-2 3M7 9h5M7 13h9" stroke="#FFD23A" stroke-width="2" stroke-linecap="round"/>`,
  ),
};
